import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CHIFFRES } from '../data/site';
import Bande from './Bande';

gsap.registerPlugin(ScrollTrigger);

export default function Chiffres() {
  const zone = useRef(null);

  useEffect(() => {
    const el = zone.current;
    if (!el) return;
    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ctx = gsap.context(() => {
      el.querySelectorAll('[data-cible]').forEach((n) => {
        const cible = Number(n.dataset.cible);
        if (reduit) { n.textContent = String(cible); return; }
        const obj = { v: 0 };
        gsap.to(obj, {
          v: cible,
          duration: 1.4,
          ease: 'power2.out',
          scrollTrigger: { trigger: n, start: 'top 88%', once: true },
          onUpdate: () => { n.textContent = String(Math.round(obj.v)); },
        });
      });
    }, el);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={zone} className="bg-marine text-white relative overflow-hidden">
      <div className="absolute inset-0 trame-diagonale" aria-hidden="true" />
      <Bande hauteur={5} />
      <div className="conteneur py-14 sm:py-16 relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10">
          {CHIFFRES.map((c) => (
            <div key={c.libelle} className="border-l-4 border-jaune pl-4 sm:pl-5">
              <p className="font-display text-[38px] sm:text-[50px] leading-none">
                <span className="text-white/70 text-[26px] sm:text-[32px]">{c.prefixe}</span>
                <span data-cible={c.valeur}>0</span>
                <span className="text-jaune">{c.suffixe}</span>
              </p>
              <p className="mt-2.5 text-[14.5px] leading-snug text-white/70">{c.libelle}</p>
            </div>
          ))}
        </div>
      </div>
      <Bande hauteur={5} />
    </section>
  );
}
